import { NavLink } from "react-router";
import { BarChart3, FileText, Grid3x3, CreditCard, Settings, LogOut } from "lucide-react";
import { AccountSwitcher } from "./AccountSwitcher";
import { useStore } from "@/lib/store";
import { authApi } from "@/lib/api";

const navItems = [
  { to: "/dashboard", icon: BarChart3, label: "Overview", end: true },
  { to: "/dashboard/posts", icon: FileText, label: "Posts", pro: true },
  { to: "/dashboard/heatmap", icon: Grid3x3, label: "Heatmap", pro: true },
  { to: "/dashboard/billing", icon: CreditCard, label: "Billing" },
  { to: "/dashboard/settings", icon: Settings, label: "Settings" },
];

export function Sidebar() {
  const isPro = useStore((s) => s.isPro());

  async function handleLogout() {
    await authApi.logout();
    window.location.href = "/";
  }

  return (
    <aside className="flex h-full w-60 flex-col border-r border-border bg-white">
      {/* Logo */}
      <div className="flex h-14 items-center border-b border-border px-4">
        <span className="text-lg font-bold tracking-tight">Yarnalytics</span>
      </div>

      {/* Account switcher */}
      <div className="border-b border-border p-2">
        <AccountSwitcher />
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-2 space-y-0.5">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors ${
                isActive
                  ? "bg-surface font-semibold text-black"
                  : "text-neutral-500 hover:bg-surface-hover hover:text-black"
              }`
            }
          >
            <item.icon className="h-5 w-5" />
            <span>{item.label}</span>
            {item.pro && !isPro && (
              <span className="ml-auto rounded bg-neutral-100 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-neutral-400">
                Pro
              </span>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Logout */}
      <div className="border-t border-border p-2">
        <button
          onClick={handleLogout}
          className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm text-neutral-500 hover:bg-surface-hover hover:text-black transition-colors"
        >
          <LogOut className="h-5 w-5" />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}
